module.exports = __webpack_public_path__ + "img/red.9e38be46.png";